import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
  provideHttpClient,
} from '@angular/common/http';
import { ModalService } from './app/shared/components/modal/services/modal.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './app/shared/services/auth.interceptor';
import { AuthService } from './app/auth/components/login/services/auth.service';

export function HttpLoaderFactory(http: HttpClient): unknown {
  return new TranslateHttpLoader(
    http,
    'assets/i18n/',
    `.json?v=${new Date().getDay()}`
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    {
      provide: ModalService,
    },
    {
      provide: AuthService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideRouter(appRoutes),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        defaultLanguage: 'ar',
      }),
      BrowserAnimationsModule,
      HttpClientModule
    ),
    // {
    //   provide: ErrorHandler,
    //   useClass: CustomErrorHandler,
    // },
  ],
}).catch(err => console.error(err));
